import { createBrowserRouter } from 'react-router-dom';
import IndicadoresNascimentos from './pages/IndicadoresNascimentos';
import IndicadoresPrenhez from './pages/IndicadoresPrenhez';
import Descarte from './pages/Descarte';
import Error404 from './pages/Error404';
import IndicadoresDesmame from './pages/IndicadoresDesmame';
import IndicadoresCurvaABC from './pages/IndicadoresCurvaABC';
import Protocolo from './pages/Protocolo';
import NovoProtocolo from './pages/NovoProtocolo';
import AplicarProtocolo from './pages/AplicarProtocolo';
import Usuario from './pages/Usuario';
import UsuarioPropriedade from './pages/UsuarioPropriedade';
import IndicadoresPerdasPreParto from './pages/IndicadoresPerdasPreParto';
import Novidades from './pages/Novidades';
import Novidade from './pages/Novidade';

const routes = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        path: "indicadores",
        children: [
          {
            path: "nascimentos",
            element: <IndicadoresNascimentos />
          },
          {
            path: "prenhez",
            element: <IndicadoresPrenhez />
          },
          {
            path: "desmame",
            element: <IndicadoresDesmame />
          },
          {
            path: "curva_abc",
            element: <IndicadoresCurvaABC />
          },
          {
            path: "perda_pre_parto",
            element: <IndicadoresPerdasPreParto />
          }
        ]
      },
      {
        path: "cadastros",
        children: [
          {
            path: "descarte",
            element: <Descarte />
          },
          {
            path: "protocolo",
            element: <NovoProtocolo />
          },
          {
            path: "uso_protocolo",
            element: <AplicarProtocolo />
          },
          {
            path: "usuario_propriedade",
            element: <UsuarioPropriedade />
          },
          {
            path: "novidade",
            element: <Novidade />
          }
        ]
      },
      {
        path: "listar",
        children: [
          {
            path: "protocolo",
            element: <Protocolo />
          },
          {
            path: "usuario",
            element: <Usuario />
          },
          {
            path: "novidades",
            element: <Novidades />
          },
        ]
      },
      {
        path: "editar",
        children: [
          {
            path: "confirma_fase_protocolo",
            element: <AplicarProtocolo />
          },
        ]
      },
      {
        path: "*",
        element: <Error404 />,
      },
      {
        path: "/",
        element: <Error404 />,
      }
    ],
  }
]);

export default routes;